let key = {
    API_URL: process.env.REACT_APP_API_URL,
    MODE: process.env.REACT_APP_MODE,
};

export default key;